import { useMutation, useQueryClient } from 'react-query'
import FilesAndDirectoriesService from '../../../services/FilesAndDirectoriesService'
import { useParams } from 'react-router-dom'

type MovePayload = {
  organization: string
  path: string
  newPath: string
  selectedProjects: string[]
}
export const useItemBulkMove = (directoryPath?: string) => {
  const queryClient = useQueryClient()
  const { org, project } = useParams()

  return useMutation<any, Error, MovePayload>({
    mutationKey: ['bulk-move-items'],
    mutationFn: async ({ organization, selectedProjects, path, newPath }) => {
      await Promise.all(
        selectedProjects.map((name) =>
          FilesAndDirectoriesService.move(
            organization,
            `${path}${name}`,
            `${newPath}`,
            name.includes('.') ? 'files' : 'directories',
          ),
        ),
      )
    },
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
